export const SESSION_EXPIRED_STORAGE_KEY = 'signin_session_expired_until'
export const SESSION_EXPIRED_VISIBLE_MS = 10000

export function readSessionExpiredUntil(): number {
  const rawValue = sessionStorage.getItem(SESSION_EXPIRED_STORAGE_KEY)
  if (!rawValue) return 0

  const parsedValue = Number(rawValue)
  if (Number.isNaN(parsedValue)) return 0

  return parsedValue
}

export function hasSessionExpiredNotice(): boolean {
  return readSessionExpiredUntil() > Date.now()
}

export function saveSessionExpiredNotice(durationMs: number = SESSION_EXPIRED_VISIBLE_MS): number {
  const visibleUntil = Date.now() + durationMs
  sessionStorage.setItem(SESSION_EXPIRED_STORAGE_KEY, String(visibleUntil))
  return visibleUntil
}
